<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
  <carousel>
    <slide v-for="(item, index) in carouselImages.slice(0, 5)" :key="index">
    <h4>{{item.id}}</h4>
    <img :src="item.thumbnailUrl" alt="Image">
    </slide>
  </carousel>
    <router-link to="/about-beagles">About Beagles</router-link>
    <router-link to="/volunteer">Volunteer</router-link>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import axios from 'axios';

export default {
  name: 'HelloWorld',
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      msg: 'Welcome to Triangle Beagle Rescue Of NC',
      carouselImages: {},
    };
  },
  async created() {
    try {
      const response = await axios.get('https://jsonplaceholder.typicode.com/photos');
      this.carouselImages = response.data;
    } catch (e) {
      this.errors.push(e);
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue